module.exports = __webpack_public_path__ + "ece562ce0844b932bf8b3174e6906996.svg";